class BambooHero {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-bamboo-hero-track]');
    this.viewport = section.querySelector('[data-bamboo-hero-viewport]');
    this.cards = section.querySelectorAll('[data-bamboo-hero-card]');
    this.stats = section.querySelectorAll('[data-bamboo-hero-stat]');
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.isDesktop = window.matchMedia('(min-width: 990px)').matches;

    if (this.track && this.viewport && this.isDesktop && !this.prefersReducedMotion) {
      this.initCarousel();
    } else if (this.track) {
      this.bindCarouselPause();
    }

    this.bindCountUp();
  }

  initCarousel() {
    this.offset = 0;
    this.speed = 0.45;
    this.paused = false;
    this.halfWidth = 0;
    this.rafId = null;

    this.track.classList.add('is-js-driven');
    this.measure();
    this.bindCarouselPause();
    this.loop = this.loop.bind(this);
    this.rafId = requestAnimationFrame(this.loop);

    window.addEventListener('resize', () => {
      this.isDesktop = window.matchMedia('(min-width: 990px)').matches;
      this.measure();
    });
  }

  measure() {
    if (!this.track) return;
    this.halfWidth = this.track.scrollWidth / 2;
  }

  bindCarouselPause() {
    if (!this.track) return;

    this.cards.forEach((card) => {
      const pause = () => {
        this.paused = true;
        this.track.classList.add('is-paused');
      };
      const resume = () => {
        this.paused = false;
        this.track.classList.remove('is-paused');
      };

      card.addEventListener('mouseenter', pause);
      card.addEventListener('mouseleave', resume);
      card.addEventListener('focusin', pause);
      card.addEventListener('focusout', resume);
    });
  }

  loop() {
    if (!this.paused && this.halfWidth > 0) {
      this.offset -= this.speed;

      if (Math.abs(this.offset) >= this.halfWidth) {
        this.offset = 0;
      }

      this.track.style.transform = `translate3d(${this.offset}px, 0, 0)`;
    }

    this.updateSpotlight();
    this.rafId = requestAnimationFrame(this.loop);
  }

  updateSpotlight() {
    if (!this.viewport) return;

    const vpRect = this.viewport.getBoundingClientRect();
    const center = vpRect.left + vpRect.width * 0.52;
    const half = vpRect.width * 0.5;

    this.cards.forEach((card) => {
      const img = card.querySelector('.bamboo-hero__card-img');
      const isFocused = card.matches(':hover') || card.matches(':focus-within');

      if (isFocused) {
        card.style.transform = 'translate3d(0, -10px, 0) scale(1.04)';
        card.style.opacity = '1';
        if (img) img.style.transform = 'translate3d(0, -4px, 0) scale(1.03)';
        return;
      }

      const rect = card.getBoundingClientRect();
      const cardCenter = rect.left + rect.width * 0.5;
      const dist = (cardCenter - center) / half;
      const absDist = Math.min(Math.abs(dist), 1);
      const focus = 1 - absDist;

      const scale = 0.94 + focus * 0.06;
      const yLift = -focus * 6;
      const imgShift = dist * -14;

      card.style.transform = `translate3d(0, ${yLift}px, 0) scale(${scale})`;
      card.style.opacity = '1';

      if (img) {
        img.style.transform = `translate3d(${imgShift}px, 0, 0)`;
      }
    });
  }

  easeOutExpo(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }

  countUp(el) {
    const target = Number(el.dataset.target);
    const suffix = el.dataset.suffix || '';
    const useLocale = el.dataset.locale === 'true';
    const duration = 1800;
    let startTime = null;

    const frame = (ts) => {
      if (!startTime) startTime = ts;
      const progress = Math.min((ts - startTime) / duration, 1);
      const value = Math.floor(this.easeOutExpo(progress) * target);

      el.textContent = useLocale
        ? `${value.toLocaleString('de-DE')}${suffix}`
        : `${value}${suffix}`;

      if (progress < 1) requestAnimationFrame(frame);
    };

    requestAnimationFrame(frame);
  }

  bindCountUp() {
    if (!this.stats.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.target.dataset.counted === 'true') return;
          entry.target.dataset.counted = 'true';
          this.countUp(entry.target);
        });
      },
      { threshold: 0.6 }
    );

    this.stats.forEach((stat) => observer.observe(stat));
  }
}

document.querySelectorAll('[data-bamboo-hero]').forEach((section) => {
  new BambooHero(section);
});
